import { Platform } from 'react-native';

export const styles = {
  root: `mt-safe min-w-full absolute top-xs transform px-lg md:right-xl md:top-xl lg:right-2xl lg:top-2xl md:min-w-0 ${Platform.OS === 'web' ? 'web:fixed web:top-lg' : ''} z-[2]`,
  container: 'gap-sm lg:gap-md',
};
